import { mapState } from 'vuex'
import TheBreadcrumbs from '@/components/common/TheBreadcrumbs/TheBreadcrumbs'
import DataTable from '@/components/common/DataTable/DataTable'
import ReservationDialog from '@/components/page/ReservationDialog/ReservationDialog'
import _ from 'lodash'
import VueScrollTo from 'vue-scrollto'
import Constants from '@/utils/Constants'

export default {
  name: 'pagereservationlist',
  layout: 'LayoutDefault',
  components: {
    TheBreadcrumbs: TheBreadcrumbs,
    DataTable: DataTable,
    ReservationDialog: ReservationDialog
  },
  data: () => ({
    breadcrumbs: [
      {
        text: 'ダッシュボード',
        disabled: false,
        href: '/'
      },
      {
        text: '分析予約一覧',
        disabled: true,
        href: 'breadcrumbs_link_2'
      }
    ],
    searchWord: '',
    company: 0,
    companies: [
      { text: 'A会社', value: '1' },
      { text: 'B会社', value: '2' }
    ],
    selectionState: { selectedCount: 0, disableAllSelected: true },
    showDialog: false,
    reservationItem: {
      id: -1,
      memo: '',
      publicSetting: 'Private'
    }
  }),
  created () {
    console.log('ReservationList created')
  },
  filters: {
  },
  computed: {
    ...mapState({
      list: state => state.pagereservationlist.list
    }),
    reservation_publish_setting_flag () {
      return Constants.getContract('reservation_publish_setting_flag')
    }
  },
  methods: {
    onSelectionChanged (selection, disableAllSelected) {
      this.selectionState = {
        selectedCount: selection.length,
        disableAllSelected: disableAllSelected
      }
    },
    refreshPage () {
      this.getReservationList(
        1,
        null,
        null
      )
    },
    onPagination (pagination) {
      this.getReservationList(
        pagination.page,
        pagination.sortBy,
        pagination.descending,
        this.searchWord
      )
      VueScrollTo.scrollTo('body', 500)
    },
    onDeleteItems (items) {
      let deleteIds = _.map(items, 'id')
      this.$store.dispatch('pagereservationlist/doDelete', deleteIds)
      console.log(deleteIds)
    },
    onEdit (item) {
      this.showDialog = true
      let editData = _.clone(item)
      if (this.reservation_publish_setting_flag === 0) {
        editData.publishSetting = '0'
      } else {
        if (editData.publish_setting === 'Public') {
          editData.publishSetting = '1'
        } else {
          editData.publishSetting = '0'
        }
      }

      if (editData.dashboard_flag === '表示しない') {
        editData.dashboardFlag = '0'
      } else {
        editData.dashboardFlag = '1'
      }
      this.$refs.reservationDialog.editData = editData
    },
    onClose () {
      this.showDialog = false
    },
    onUpdate (editData) {
      this.doUpdateReservation(editData)
      this.showDialog = false
    },
    getReservationList (pageNo, sortField, sortType) {
      this.$store.dispatch('pagereservationlist/getReservationList', {
        pageNo: pageNo,
        sortField: sortField,
        sortType: sortType
      })
    },
    doUpdateReservation (editData) {
      this.$store.dispatch('pagereservationlist/doUpdate', editData)
    }
  },
  metaInfo () {
    this.$store.dispatch('meta/set', {
      title: '分析予約一覧',
      meta: [
        {
          name: 'description',
          content: '分析予約一覧'
        }
      ]
    })
    return this.$store.getters['meta/get']
  }
}
